import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { CollectionRulesInput } from '@nucleus-commerce/api-client/admin';

import { collectionsApi } from '../api/collections-api';

import { collectionKeys } from './collection-keys';

const NO_RULES: CollectionRulesInput = { match: 'all', conditions: [] };

/**
 * Evaluates a rule set without saving. The caller debounces and passes null while the rules
 * are incomplete; the query is then disabled and the previous result stays on screen.
 */
export function usePreviewRules(storeId: string, rules: CollectionRulesInput | null) {
  return useQuery({
    queryKey: collectionKeys.preview(storeId, rules ?? NO_RULES),
    queryFn: () => collectionsApi.previewRules(storeId, rules ?? NO_RULES),
    enabled: rules !== null,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
